import React, { Component } from 'react'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import moment from 'moment'
import HelperContainer from '../../util/HelperContainer'
import Api from '../../util/Api'
import $ from 'jquery';

class CarInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            records: null,
            carRows: [
                { plate: '', type: '', description: '', expense1: '', expense2: '' }
            ],
            expenseList:[]
        }
    }

    componentWillMount() {
        this.fetchRecordedData();
    }

    fetchRecordedData() {
        this.setState({ records: [] });
        Api.get("/company/carInfo", (response, errors) => {
            if (errors) return;
            let getData = response.data;
            this.setState({ records: getData });
        });
        Api.get("/DBS/purchaseExpenseCategoriesSelect/list/1/okc", (response, errors) => {
            if (errors) return;
            let getData = response.purchaseExpenseCategories;
            this.setState({ expenseList: getData });
        });
    }

    handleChange = (index, field, value) => {
        const newRows = [...this.state.carRows];
        newRows[index][field] = value;
        if (field === 'type' && value === '0') {
            newRows[index]['expense2'] = '';
        }
        
        this.setState({ carRows: newRows });
    }

    handleAddRow = () => {
        this.setState(prevState => ({
            carRows: [...prevState.carRows, { plate: '', type: '', description: '', expense1: '', expense2: '' }]
        }));
    }
    handleRemoveRow = (index) => {
        const newRows = [...this.state.carRows];
        newRows.splice(index, 1);
        this.setState({ carRows: newRows });
    }
    componentDidMount() {
        this.fetchInitialData();
    }

    fetchInitialData = () => {
        Api.get("/company/getCarInfo", (response, error) => {
            if (error) {
                console.error("API hatası:", error);
                return this.setState({
                    carRows: [{ plate: '', type: '', description: '', expense1: '', expense2: '' }]
                });
            }

            let data = response;

            if (!Array.isArray(data) || data.length === 0) {
                data = [{ plate: '', type: '', description: '', expense1: '', expense2: '' }];
            }

            this.setState({ carRows: data });
        });
    }

    handleSubmit = () => {
        const data = this.state.carRows;
        Api.post("/company/carInfo", { data: (data) }, function(
            res,
            err
        ) {
            toastr.success('Başarılı', 'Veriler başarıyla kaydedildi.');
        });
    }

    render() {
        return (
            <>
                <div className="container mt-3">
                    <h5>Araç Bilgileri</h5>

                    {this.state.carRows.map((row, index) => (
                        <div key={index} className="d-flex align-items-center mb-2" style={{"marginBottom":"4px"}}>
                            <div className="row w-100">
                                <div className="col-md-1 d-flex flex-column">
                                    <button
                                        className="btn btn-primary btn-sm mb-1"
                                        onClick={this.handleAddRow}
                                        type="button"
                                    >+</button>

                                    {this.state.carRows.length > 1 && (
                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => this.handleRemoveRow(index)}
                                            type="button"
                                        >-</button>
                                    )}
                                </div>
                                <div className="col-md-2">
                                    <input
                                        type="text"
                                        placeholder="Araç Plakası"
                                        value={row.plate}
                                        onChange={(e) => {
                                            const upperCasePlate = e.target.value.toUpperCase().replace(/\s+/g, '');
                                            this.handleChange(index, 'plate', upperCasePlate);
                                        }}
                                        className="form-control mr-2"
                                    />
                                </div>
                                <div className="col-md-2">
                                    <select
                                        value={row.type}
                                        onChange={(e) => this.handleChange(index, 'type', e.target.value)}
                                        className="form-control mr-2"
                                    >
                                        <option value="">Seçiniz</option>
                                        <option value="0">Ticari</option>
                                        <option value="1">Binek</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <input
                                        type="text"
                                        placeholder="Açıklama"
                                        value={row.description}
                                        onChange={(e) => this.handleChange(index, 'description', e.target.value)}
                                        className="form-control"
                                    />
                                </div>
                                <div className="col-md-2">
                                    <select
                                        value={row.expense1}
                                        onChange={(e) => this.handleChange(index, 'expense1', e.target.value)}
                                        className="form-control mr-2"
                                    >
                                        <option value="">Gider Kategorisi</option>
                                        {this.state.expenseList.map(expense => (
                                            <option disabled={expense && expense.disabled && expense.disabled == true?true:false} value={expense.id}>{expense.description}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <select
                                        value={row.type == '0' ? '' : row.expense2}
                                        onChange={(e) => this.handleChange(index, 'expense2', e.target.value)}
                                        className="form-control mr-2"
                                        disabled={row.type == '0'}
                                    >
                                        <option value="">Kanunen Kabul Edilmeyen Gider Kategorisi</option>
                                        {this.state.expenseList.map(expense => (
                                            <option disabled={expense && expense.disabled && expense.disabled == true?true:false} key={expense.id} value={expense.id}>{expense.description}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className="text-right mt-3">
                        <button
                            className="btn btn-primary"
                            onClick={this.handleSubmit}
                            type="button"
                        >
                            Kaydet
                        </button>
                    </div>

                </div>
            </>
        );
    }

}

function mapStateToProps(state) {
    return {
        records: state.data.records
    };
}

export default connect(mapStateToProps, actions)(CarInfo);
